module.exports = __webpack_public_path__ + "static/media/background-genesys.dda7660d.jpg";